export const VOICEMAIL_BADGE_LABEL = "Voicemail"

export function VoicemailBadge() {
  return (
    <span
      aria-label={VOICEMAIL_BADGE_LABEL}
      className="inline-flex h-5 flex-shrink-0 items-center justify-center rounded-sm border border-sky-300 bg-sky-100 px-1 text-[10px] font-semibold leading-none text-sky-700"
    >
      VM
    </span>
  )
}
